export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0020.50965c11.webp";